import infoboard from '../infoboard';
import templates from '../templates';

const tradearea = (() => {
    let _visible = false;
    let $dialog = null;
    let $template = null;

    const _close = () => $dialog.close();

    const _onClose = () => {
        _visible = false;
        $dialog.destroy();
        $template.remove();
    };

    return (values, actions) => {
        if (_visible) {
            return;
        }

        _visible = true;

        $template = $(templates('dialog-tradearea', values));

        $template.on('keyup keypress blur change', 'input, textarea', (e) => {
            if (e.keyCode === 13) {
                e.preventDefault();
            }

            infoboard.updateInputLabel(e.target);
        });

        $template.find('input').each((index, el) => infoboard.updateInputLabel(el));

        $template.find('input[name=\'Anel3\']').on('change', (e) => {
            const value = Number(String(e.target.value).replace(/[^\d\.\-\ ]/g, '')) / 10;
            $template.find('input[name=\'Anel1\']').val(Math.round((value * 3) * 100) / 100);
            $template.find('input[name=\'Anel2\']').val(Math.round((value * 6) * 100) / 100);
            if ($template.find('input[type=\'radio\']').is(':checked')) {
                actions.calculate($template, e);
            }
        });

        $template.find('.submit').on('click', (e) => {
            _close($template);
            actions.submit($template, e);
        });

        $template.find('.cancel').on('click', (e) => {
            _close($template);
            actions.cancel(e);
        });

        const checkboxes = $template.find('input[type=\'radio\']').iCheck({
            radioClass: 'iradio_square-blue',
            checkboxClass: 'icheckbox_square-blue'
        });

        checkboxes.on('ifChecked', (e) => {
            actions.calculate($template, e);
            $template.find('.submit').attr('disabled', false);
        });

        $dialog = $template.kendoWindow({
            width: '360px',
            resizable: false,
            draggable: true,
            visible: false,
            title: false,
            appendTo: 'body',
            close: _onClose
        }).data('kendoWindow');

        $dialog.center().open();

        return $dialog;
    };
})();

export default tradearea;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/tradearea.js